<div class="container-forgot">
  <!-- LOGO del progetto -->
  <div class="logo-forgot">
    <a href="https://workinc.vtserver.eu/" target="_blank">
      <img src="img/logo_white.png" [attr.alt]="'auth.logo-alt' | translate" />
    </a>
  </div>

  <div class="forgot-box">
    <h2>{{ 'auth.forgot-password.title' | translate }}</h2>

    <form (ngSubmit)="recoveryPassword()">

      <app-alert-message [iconStyle]="{ top: '0rem', right: '0rem' }"></app-alert-message>

      <label for="email">{{ 'auth.fields.email' | translate }}</label>
      <input type="email" id="email" name="email" [(ngModel)]="email" placeholder="{{ 'auth.forgot-password.email-placeholder' | translate }}" required />

      <button type="submit" >{{ 'auth.forgot-password.submit' | translate }}</button>

      <div class="back-to-login-container">
        <a routerLink="/login" class="back-to-login-button">
          <mat-icon>arrow_back</mat-icon>
          {{ 'auth.back-to-login' | translate }}
        </a>
      </div>

    </form>
  </div>
</div>
